import type { IssueListItem } from "@/pages/Tasks/Issue/config"
import { useHttpClient } from "@/vf"

const starredIds = new Set<string>()
let loaded = false

export function useIssueStarred(apiBase: string = "tasks/issue/") {
    const http = useHttpClient()

    async function loadStarredIssues() {
        const ids = (await http.get<string[]>(apiBase + "starred-issue-ids")).data
        starredIds.clear()
        for (const id of ids) {
            starredIds.add(id)
        }
        loaded = true
    }

    function applyStarredState(issues: IssueListItem[]) {
        for (const issue of issues) {
            issue.starred = starredIds.has(issue.id!)
        }
    }

    async function toggleStarred(issue: IssueListItem) {
        const newStarred = !issue.starred
        issue.starred = (await http.post<boolean>(apiBase + issue.id + "/starred", { starred: newStarred })).data
        if (issue.starred) {
            starredIds.add(issue.id!)
        } else {
            starredIds.delete(issue.id!)
        }
    }

    return { loadStarredIssues, applyStarredState, toggleStarred, loaded: () => loaded }
}
